import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("TemplateTitleOutput")
export class TemplateTitleOutput {
    @JsonProperty()
    public title: string = JsonPropertyEmpty;

    @JsonProperty()
    public deleted: boolean = false;

    public constructor(args?: Partial<TemplateTitleOutput>) {
        Object.assign(this, args);
    }
}
